import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./rounded-pill.module.css";

interface RoundedPillProps {
    label: string;
    to?: string;
    onClick: () => void;
}

export default function RoundedPill({ label, to, ...props }: RoundedPillProps): JSX.Element {
    function onClick(e: React.MouseEvent<HTMLElement>): void {
        e.preventDefault();
        props.onClick();
    }

    return (
        <a role="button" href={to} rel="nofollow" className={styles.pill} onClick={onClick}>
            <span>{label}</span>
            <span className={styles.icon}>
                <SVGIcon name={"close"} />
            </span>
        </a>
    );
}
